import { MONEY_SYMBOLS } from '@cesare';

export function isRunningLocally() {
  return /joandjoe.local/.test(window.location.href);
}

export function roundPriceToTwoDecimals(priceValue: number) {
  return Number.parseFloat(String(priceValue)).toFixed(2);
}

export function getCurrencyText(currencyCode: string) {
  return MONEY_SYMBOLS[currencyCode];
}
